import { render, staticRenderFns } from "./ConceptSlide.vue?vue&type=template&id=0989f4f2&scoped=true&"
import script from "./ConceptSlide.vue?vue&type=script&lang=js&"
export * from "./ConceptSlide.vue?vue&type=script&lang=js&"
import style0 from "./ConceptSlide.vue?vue&type=style&index=0&id=0989f4f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0989f4f2",
  null
  
)

export default component.exports